<template>
  <div class="boBiG">
    <el-container class="containerStyle">
      <el-header class="HearseStyle">直播详情页</el-header>
      <el-container>
        <el-aside width="200px">
          <el-menu default-active="1" class="el-menu-vertical-demo" background-color="#545c64" text-color="#fff"
            active-text-color="#ffd04b">
            <el-menu-item v-for="(item, index) in menuLeft" :key="index" @click="ClickList(item)">
              <i v-if="item.icon" :class="item.icon"></i>
              <span slot="title" :class="item.icon? 'IconTrue' : 'IconFalse'">{{item.name}}</span>
            </el-menu-item>
          </el-menu>
        </el-aside>
        <el-main class="maincon">
          <div class="topcont">
            <div class="leftContent">
              <div class="titile">直播信息</div>
              <div class="tentmar">主题：{{info.subject}}</div>
              <div class="tentmar">直播时间：{{info.t_start}}</div>
              <!-- <div class="tentmar">状态：{{info.type}}</div> -->
              <div class="tentmar">模式：{{info.mode}}</div>
              <div class="tentmar">观看限制：{{info.look}}</div>
              <div class="tentmar">嘉宾助理功能：{{info.jiabing}}</div>
              <div class="tentmar">报名表单：{{info.baoming}}</div>
              <div class="tentmar">观看页面地址:
                <el-input style="width: 300px;" v-model="inputAdress" id="liveUrl"></el-input>
                <el-button size="mini" @click="clickCopy">复制</el-button>
              </div>
            </div>
            <div class="RightContent">
              <img v-if="img_url" :src="img_url" alt="">
              <el-image v-else>
                <div slot="error" class="image-slot">
                  <i class="el-icon-picture-outline"></i>
                </div>
              </el-image>
              <div class="dibuspa">
                <span>
                  <span>分享至</span>
                  <span>QQ</span>
                  <span>微博</span>
                  <span>微信</span>
                </span>
                <el-button type="success" size="mini">微信观看</el-button>
              </div>
              <!-- <div class="startLIve" @click="LookLiveClick">开始直播</div> -->
            </div>
          </div>
          <div class="bottomcont">
            <div class="titile">直播数据</div>
            <el-row>
              <el-col :span="6">
                <img src="../../assets/images/detail-1.png" alt="">
                <div class="tworight">
                  <div>最高并发（人）</div>
                  <div>0</div>
                </div>
              </el-col>
              <el-col :span="8">
                <img src="../../assets/images/detail-2.png" alt="">
                <div class="tworight">
                  <div><span>累计观看次数（次）</span><span>查看详情</span></div>
                  <div><span>0直播</span>&emsp;<span>0回放</span></div>
                </div>
              </el-col>
              <el-col :span="10">
                <img src="../../assets/images/detail-3.png" alt="">
                <div class="tworight">
                  <div><span>累计观看人数（人）</span></div>
                  <div><span>1访问次数</span>&emsp;<span>0直播</span>&emsp;<span>0回放</span></div>
                </div>
              </el-col>
            </el-row>
          </div>
        </el-main>
      </el-container>
    </el-container>
  </div>
</template>

<script>
  import { netmettingfetch } from '@/api/VhallLive'
  import Cookies from 'js-cookie'
  export default {
    name: 'LiveDetail',
    data() {
      return {
        menuLeft: [
          { icon: 'el-icon-menu', name: '直播列表', title: 1, linkUrl: 'Livelist' },
          // { icon: 'el-icon-delete', name: '删除', title: 1, linkUrl: '1' },
          { icon: 'el-icon-s-tools', name: '编辑', title: 1, linkUrl: 'CreatVhall' }
        ],
        info: {
          subject: '',
          t_start: '',
          type: '', // 1为直播，2为预约,3为结束，4为点播，5 结束且有自动回放
          mode: '', // 暂无字段
          look: '',
          jiabing: '',
          baoming: '',
          yemian: '',
          img_url: '',
        },
        img_url: '',
        inputAdress: ''
      }
    },
    mounted() {
      if (this.$route.params.item) {
        // console.log(this.$route.params.item)
        this.img_url = this.$route.params.item.imgUrl
        this.apiSend(this.$route.params.item.webinarId)
        // 正式环境和测试环境访问的直播地址判断
        this.inputAdress = `http://live.vhall.com/${this.$route.params.item.webinarId}`
        // this.inputAdress = process.env.NODE_ENV === 'development' ? 'http://localhost:8080/#/LookLiveG' : `${process.env.BASE_API}/#/LookLiveG`
      }
    },
    methods: {
      // 详情数据的获取
      apiSend(webinar_id) {
        var obj = {
          webinar_id: webinar_id
        }
        netmettingfetch(obj).then(response => {
        //   console.log(response)
          this.info = response.data
        })
      },
      // 复制
      clickCopy() {
        const inputElment = document.querySelector('#liveUrl')
        inputElment.select()
        if (document.execCommand('copy')) {
          document.execCommand('copy')
          alert('复制成功')
        }
      },
      // 开始直播
      LookLiveClick() {
        // console.log(this.$route.params)
        Cookies.set('webinarId', this.$route.params.item.webinarId)
        const { href } = this.$router.resolve({
          name: "LookLive",
          params: { webinarId: this.$route.params.item.webinarId }
        })
        window.open(href, '_blank')
      },
      // 左侧导航的点击
      ClickList(itemLink) {
        this.$router.push({ name: itemLink.linkUrl, params: { item: this.$route.params.item } })
      }
    }
  }
</script>

<style scoped lang="scss">
  .boBiG {
    width: 100%;
    height: 100%;
    background-color: #cdcdcd;
  }

  .el-container,
  .el-aside,
  .el-menu {
    height: 100%;
  }

  .containerStyle {
    width: 90%;
    height: 100%;
    margin: 0px auto;
    background-color: white;

    .HearseStyle {
      display: flex;
      align-items: center;
      font-size: 18px;
    }

    .el-menu-item {
      height: 40px;
      line-height: 40px;
    }

    .IconTrue {
      font-size: 18px;
    }

    .IconFalse {
      margin-left: 35px;
    }

    .maincon {
      .topcont {
        height: 60%;
        width: 100%;

        .leftContent {
          height: 100%;
          width: 50%;
          float: left;

          .titile {
            margin-left: 15px;
            font-size: 20px;
          }

          div {
            height: 40px;
            line-height: 40px
          }

          .tentmar {
            text-align: center;
          }
        }

        .RightContent {
          height: 100%;
          width: 50%;
          float: left;
          position: relative;

          img {
            width: 400px;
            height: 200px;
            margin-left: calc(50% - 200px);
            margin-top: 50px;
          }

          .dibuspa {
            margin-top: 30px;
            display: flex;
            align-items: center;
            justify-content: space-around;
          }

          .startLIve {
            height: 100px;
            width: 100px;
            border-radius: 50%;
            background-color: crimson;
            display: flex;
            align-items: center;
            justify-content: center;
            color: white;
            position: absolute;
            bottom: 10px;
            right: 100px;
            cursor: pointer;
          }
        }
      }

      .bottomcont {
        height: calc(40% - 1px);
        width: 100%;
        /* background-color: silver; */
        border-top: 1px solid #cdcdcd;

        .titile {
          margin-left: 15px;
          font-size: 20px;
        }

        .el-row {
          margin-top: 30px;

          img {
            width: 80px;
            float: left;
          }

          .tworight {
            float: left;
            margin-top: 20px;
            margin-left: 20px;
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/Live-Platform/Live-Detail.vue